<script lang="ts">
    import {Flex, Spacer} from 'shared/layouts';
    import type {DatatypedFilterDefinition} from '../../types';
    import {getSearchFieldTypeFiltersContext} from '../../search-field-type-filters.context';
    import {cleanup, exists} from 'shared/utils/custom-utils';
    import {onDestroy} from 'svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import FilterButton from './FilterButton.svelte';

    export let filterableDatatypeDefinition: DatatypedFilterDefinition;
    export let value: any;

    const context = getSearchFieldTypeFiltersContext();

    let filterActive = false;
    const filteredValuesUnsubscribe = context.filteredValues$.subscribe((filteredValues) => filterActive = exists(filteredValues[filterableDatatypeDefinition.fieldName]));

    onDestroy(() => {
        cleanup(filteredValuesUnsubscribe);
    });

    const handleRemoveFilter = () => {
        context.removeFilteredValue(filterableDatatypeDefinition.fieldName);
    };
</script>

<Spacer direction="vertical" size="ml"/>

<Flex direction="column" gap="s">
    {#if exists($$slots.default)}
        <slot {filterableDatatypeDefinition} {value}/>
    {:else}
        <FilterButton {filterableDatatypeDefinition} {value} icon="filter" defaultFilter>
            Filtrovat
        </FilterButton>
    {/if}
</Flex>

<Spacer direction="vertical" size="sm"/>
<KpButton isDisabled={!filterActive} buttonSize="sm" buttonStyle="danger" on:click={handleRemoveFilter}>
    <IconedContent icon="cross-circle">Vymazat filtr</IconedContent>
</KpButton>